import { useEffect, useState } from "react";
import { MODULE_API } from "../../../../apis";

const ParentModules = [
  "Personal and Family Information",
  "Emergency Contacts",
  "Property Documentation",
  "Financial Documentation",
  "Important Documents Storage",
  "Emergency Supplies Inventory",
  "Evacuation Planning",
  "Home Safety And Security",
  "Communication Plan",
  "Insurance Coverage",
  "Recovery Plan",
  "Business Continuty",
  "Personal Information Divorce",
  "Asset Documentation",
  "Business Interests",
  "Child Support Calculations",
  "Income Adjustments",
  "Child Related Expenses",
  "Child Custody Considerations",
];

export default function useGetAttributes(moduleNames, setLoading) {
  const [attributes, setAttributes] = useState([]);
  const [disasterAttribute, SetDisasterAttribute] = useState(null);
  const [error, setError] = useState(null);

  const getAttributes = async () => {
    setLoading(true);
    setError(null);

    try {
      const results = await Promise.all(
        moduleNames &&
          moduleNames.map(async (name) => {
            try {
              const res = await MODULE_API.fetchAttributes(name);
              console.log("Fetched response for", name, "=>", res);
              if (res && ParentModules.includes(res.name)) {
                console.log("Parent module detected:", res.name);
                console.log("Parent attributes:", res.attributes);
                SetDisasterAttribute(res.attributes);
              }
              return res && res.attributes
                ? { name: name, attributes: res.attributes }
                : null;
            } catch (err) {
              console.error(`Error fetching attributes for ${name}:`, err);
              return null;
            }
          })
      );
      console.log("All attributes fetched:", results);
      setAttributes(results);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  // Log attributes and disasterAttribute whenever they change
  useEffect(() => {
    if (moduleNames && moduleNames.length > 0) {
      getAttributes();
    }
  }, []);

  useEffect(() => {
    console.log("State => attributes:", attributes);
  }, [attributes]);

  useEffect(() => {
    console.log("State => disasterAttribute (parent):", disasterAttribute);
  }, [disasterAttribute]);

  return { attributes, disasterAttribute, error };
}
